export enum AdEvents {
    RELOAD = 'adreload',
    CHANGED = 'adchanged',
}
